"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Images = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Images = function Images(_ref) {
  var items = _ref.items;
  return _react.default.createElement(_styles.Container, null, _react.default.createElement(_styles.Content, null, items && items.map(function (item, index) {
    return _react.default.createElement(_styles.Image, {
      key: "item--".concat(index),
      srcSet: item.srcSet,
      src: item.src
    });
  })));
};

exports.Images = Images;